var render, staticRenderFns
import script from "./PatientsPurchasedTrends.vue?vue&type=script&lang=js&"
export * from "./PatientsPurchasedTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d15c686')) {
      api.createRecord('0d15c686', component.options)
    } else {
      api.reload('0d15c686', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/trending-charts/PatientsPurchasedTrends.vue"
export default component.exports